import React, { ReactElement } from 'react'

import Container from './Container'

interface PrivacyPolicyProps {
    onClose: () => void
}

const PrivacyPolicy = ({ onClose }: PrivacyPolicyProps): ReactElement => {
    return (
        <Container
            onClose={onClose}
            url={process.env.REACT_APP_EXTERNAL_LINK_PRIVACY_POLICY}
        />
    )
}

export default PrivacyPolicy
